/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const WORKCYCLE_SUCCESS = 'WORKCYCLE_SUCCESS';
export const WORKCYCLE_BEGIN = 'WORKCYCLE_BEGIN';
export const WORKCYCLE_FAILURE = 'WORKCYCLE_FAILURE';
export const CLEAR_WORKCYCLE = 'CLEAR_WORKCYCLE';

export const FILTER_BEGIN = 'FILTER_BEGIN';
export const FILTER_SUCCESS = 'FILTER_SUCCESS';
export const FILTER_FAILURE = 'FILTER_FAILURE';
export const FILTER_CLEAR = 'FILTER_CLEAR';

export const COMMUNICATION_DISPATCH_BEGIN = 'COMMUNICATION_DISPATCH_BEGIN';
export const COMMUNICATION_DISPATCH_SUCCESS = 'COMMUNICATION_DISPATCH_SUCCESS';
export const COMMUNICATION_DISPATCH_FAILURE = 'COMMUNICATION_DISPATCH_FAILURE';
export const COMMUNICATION_DISPATCH_CLEAR = 'COMMUNICATION_DISPATCH_CLEAR';
export const FIELDS_FILTERS_WORK_CYCLE_SUCCESS = 'FIELDS_FILTERS_WORK_CYCLE_SUCCESS';

export function fetchWorkCycle(data) {
	return async dispatch => {
		dispatch(workCyclenBegin());
		await ApiService.getWorkCycles(data)
			.then(
				result => {
					dispatch(addWorkCycle(result.Data));
				},
				error => {
					dispatch(workCyclenError());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export function setWorkCycle(data) {
	return async dispatch => {
		dispatch(workCyclenBegin());
		await ApiService.setWorkCycles(data)
			.then(
				result => {
					let normalized = normalizeById(result.Data, 'idTest');
					dispatch(addWorkCycle(normalized));
					return normalized;
				},
				error => {
					dispatch(workCyclenError());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export function fetchWorkCycleFilter(data) {
	return async dispatch => {
		dispatch(workCycleFilterBegin());
		await ApiService.getWorkCyclesFilters(data)
			.then(
				result => {
					dispatch(workCycleFilterSuccess(result));
				},
				error => {
					dispatch(workCycleFilterFailure());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export function fetchCommunicationsDispatch(id, data) {
	return async dispatch => {
		dispatch(workCycleEvaluationBegin());
		await ApiService.getCommunicationsDispatch(id, data)
			.then(
				result => {
					dispatch(workCycleEvaluationSuccess(result));
				},
				error => {
					dispatch(workCycleEvaluationFailure());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export function fetchWorkCycleFiltersFields(id, data) {
	return async dispatch => {
		dispatch(workCycleEvaluationBegin());
		await ApiService.getCommunicationsDispatch(id, data)
			.then(
				result => {
					dispatch(fetchWorkCycleFiltersFieldsSuccess(result));
				},
				error => {
					dispatch(workCycleEvaluationFailure());
					throw ({ error: error, message: 'An error ocurred' });
				}
			)
	};
}

export const workCyclenBegin = () => ({
	type: WORKCYCLE_BEGIN,
});

export const addWorkCycle = data => ({
	type: WORKCYCLE_SUCCESS,
	payload: { data }
})

export const workCyclenError = () => ({
	type: WORKCYCLE_FAILURE,
})

export const clearWorkCycle = () => ({
	type: CLEAR_WORKCYCLE,
})

//FILTER
export const workCycleFilterBegin = () => ({
	type: FILTER_BEGIN
});
export const workCycleFilterSuccess = filterData => ({
	type: FILTER_SUCCESS,
	payload: { filterData }
});
export const workCycleFilterFailure = filterError => ({
	type: FILTER_FAILURE,
	payload: { filterError }
});
export const workCycleFilterClear = () => ({
	type: FILTER_CLEAR,
})

//Evaluation
export const workCycleEvaluationBegin = () => ({
	type: COMMUNICATION_DISPATCH_BEGIN
});
export const workCycleEvaluationSuccess = filterData => ({
	type: COMMUNICATION_DISPATCH_SUCCESS,
	payload: { filterData }
});
export const workCycleEvaluationFailure = filterError => ({
	type: COMMUNICATION_DISPATCH_FAILURE,
	payload: { filterError }
});
export const workCycleEvaluationClear = () => ({
	type: COMMUNICATION_DISPATCH_CLEAR,
})

export const fetchWorkCycleFiltersFieldsSuccess = filterData => ({
	type: FIELDS_FILTERS_WORK_CYCLE_SUCCESS,
	payload: { filterData }
});
